import React from 'react'

// Importing logo
import downlogo from '../img/busicon/down-logo.png'

const Footer = () => {
  return (
    <footer>
      {/* tp-footer-area-start */}
      <div className="tp-footer__pl-pr grey-bg-2 tp-footer-style-2">
        <div className="tp-footer__area pt-90 tp-footer__tp-border-bottom">
          <div className="container">
            <div className="row">
              <div
                className="col-xl-3 col-lg-3 col-md-6 pb-30 wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                <div className="tp-footer__widget footer-widget-2 footer-col-2-1">
                  <div
                    className="tp-footer__logo mb-25"
                    style={{ textAlign: 'center' }}
                  >
                    <a href="/">
                      <img
                        src={downlogo}
                        style={{
                          height: '130px',
                          marginBottom: '20px',
                          marginLeft: '-70px',
                        }}
                        alt=""
                      />
                    </a>
                  </div>
                  <div className="tp-footer__contact-info">
                    <a
                      href="https://www.google.com/maps/place/18%C2%B005'03.1%22N+78%C2%B051'40.8%22E"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: 'none' }}
                    >
                      Head office : Near Vmart ,block office,warangal road,
                      <br />
                      siddipet ,502103, Telangana, India
                    </a>
                    <ul>
                      <li>
                        <span>
                          <svg
                            width={24}
                            height={25}
                            viewBox="0 0 24 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.5"
                              d="M7.7295 5.20453L8.56039 6.69335C9.31022 8.03693 9.00921 9.79947 7.82823 10.9805C7.82823 10.9805 7.82823 10.9805 7.82823 10.9805C7.82811 10.9806 6.39585 12.4131 8.99299 15.0102C11.5895 17.6067 13.0219 16.1758 13.0227 16.175C13.0228 16.175 13.0228 16.175 13.0228 16.1749C14.2038 14.994 15.9663 14.693 17.3099 15.4428L18.7987 16.2737C20.8275 17.406 21.0671 20.2512 19.2838 22.0345C18.2122 23.106 16.8995 23.9398 15.4484 23.9948C13.0056 24.0874 8.85699 23.4692 4.6955 19.3077C0.534019 15.1462 -0.0842204 10.9976 0.00838762 8.55479C0.0633994 7.10366 0.897189 5.79096 1.96874 4.7194C3.75204 2.93611 6.59725 3.17571 7.7295 5.20453Z"
                              fill="#01103D"
                            />
                            <path
                              d="M11.8539 0.806328C11.9387 0.282856 12.4336 -0.0722471 12.957 0.0125008C12.9894 0.0187032 13.0937 0.0381888 13.1483 0.0503544C13.2575 0.0746828 13.4099 0.11214 13.5999 0.167479C13.9799 0.278145 14.5107 0.460456 15.1477 0.752523C16.4232 1.33727 18.1205 2.36018 19.8819 4.12152C21.6432 5.88286 22.6661 7.58021 23.2509 8.85567C23.5429 9.49273 23.7252 10.0235 23.8359 10.4035C23.8913 10.5935 23.9287 10.7458 23.953 10.8551C23.9652 10.9097 23.9741 10.9536 23.9803 10.986L23.9877 11.0259C24.0724 11.5494 23.7205 12.0647 23.1971 12.1494C22.6751 12.234 22.1833 11.8806 22.0965 11.3595C22.0938 11.3456 22.0865 11.308 22.0786 11.2725C22.0628 11.2016 22.0355 11.0892 21.9922 10.9405C21.9055 10.643 21.7551 10.2009 21.5052 9.65598C21.0062 8.56739 20.1087 7.06416 18.524 5.47941C16.9392 3.89466 15.436 2.99723 14.3474 2.49816C13.8024 2.24831 13.3603 2.09784 13.0629 2.01121C12.9142 1.96789 12.7273 1.92499 12.6564 1.9092C12.1354 1.82237 11.7694 1.32831 11.8539 0.806328Z"
                              fill="#01103D"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M12.1436 5.22244C12.2893 4.71255 12.8207 4.41731 13.3306 4.56299L13.0668 5.48622C13.3306 4.56299 13.3306 4.56299 13.3306 4.56299L13.3324 4.56352L13.3344 4.56408L13.3387 4.56533L13.3486 4.56829L13.3739 4.57618C13.3932 4.58236 13.4173 4.5904 13.4461 4.60059C13.5036 4.621 13.5796 4.65001 13.6728 4.68996C13.8593 4.76989 14.1141 4.89333 14.4272 5.0786C15.0538 5.44946 15.9092 6.06547 16.9142 7.07042C17.9191 8.07536 18.5351 8.9308 18.906 9.55742C19.0913 9.87045 19.2147 10.1253 19.2946 10.3118C19.3346 10.405 19.3636 10.481 19.384 10.5385C19.3942 10.5673 19.4022 10.5914 19.4084 10.6107L19.4163 10.636L19.4193 10.6459L19.4205 10.6502L19.4211 10.6521C19.4211 10.6521 19.4216 10.654 18.4984 10.9178L19.4216 10.654C19.5673 11.1639 19.272 11.6953 18.7622 11.841C18.2566 11.9854 17.7299 11.6964 17.5789 11.1945L17.5742 11.1807C17.5674 11.1615 17.5533 11.1236 17.5296 11.0683C17.4822 10.9577 17.3963 10.7769 17.2534 10.5355C16.9679 10.0532 16.4524 9.32441 15.5563 8.42831C14.6602 7.53221 13.9314 7.01665 13.4491 6.7312C13.2077 6.58831 13.0269 6.50241 12.9163 6.45504C12.861 6.43133 12.8231 6.41721 12.8039 6.41038L12.7901 6.40565C12.2882 6.25474 11.9991 5.72799 12.1436 5.22244Z"
                              fill="#01103D"
                            />
                          </svg>
                        </span>
                        <a
                          className="first-child"
                          href="7658934523"
                          style={{ textDecoration: 'none' }}
                        >
                          +91 7658934523
                        </a>
                      </li>
                      <li>
                        <span>
                          <svg
                            width={18}
                            height={18}
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.5"
                              d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 10.4397 0.338055 11.8005 0.939116 13.0072C1.09884 13.3279 1.15201 13.6945 1.05941 14.0406L0.523359 16.044C0.290659 16.9137 1.08631 17.7093 1.95601 17.4766L3.95945 16.9406C4.30554 16.848 4.67209 16.9012 4.99278 17.0609C6.19953 17.6619 7.56029 18 9 18Z"
                              fill="#1C274C"
                            />
                            <path
                              d="M5.2425 9.7648C4.83243 9.7648 4.5 10.0972 4.5 10.5073C4.5 10.9174 4.83243 11.2498 5.2425 11.2498H10.6875C11.0976 11.2498 11.43 10.9174 11.43 10.5073C11.43 10.0972 11.0976 9.7648 10.6875 9.7648H5.2425Z"
                              fill="#1C274C"
                            />
                            <path
                              d="M5.2425 6.2998C4.83243 6.2998 4.5 6.63223 4.5 7.0423C4.5 7.45238 4.83243 7.7848 5.2425 7.7848H13.1625C13.5726 7.7848 13.905 7.45238 13.905 7.0423C13.905 6.63223 13.5726 6.2998 13.1625 6.2998H5.2425Z"
                              fill="#1C274C"
                            />
                          </svg>
                        </span>
                        <a
                          href="mailto:help@lono.org.in"
                          style={{ textDecoration: 'none' }}
                        >
                          help@lono.org.in
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-3 col-lg-3 col-md-6 pb-30 wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".5s"
              >
                <div className="tp-footer__widget footer-widget-2 footer-col-2-2">
                  <h4 className="tp-footer__widget-title">Services</h4>
                  <div className="tp-footer__content">
                    <ul>
                      <li>
                        <a href="/loans" style={{ textDecoration: 'none' }}>
                          Loans
                        </a>
                      </li>
                      <li>
                        <a href="/insurance" style={{ textDecoration: 'none' }}>
                          Insurance
                        </a>
                      </li>
                      <li>
                        <a
                          href="/legalities"
                          style={{ textDecoration: 'none' }}
                        >
                          Legal compliance
                        </a>
                      </li>
                      <li>
                        <a href="/business" style={{ textDecoration: 'none' }}>
                          Business management
                        </a>
                      </li>
                      <li>
                        <a
                          href="/collaborations"
                          style={{ textDecoration: 'none' }}
                        >
                          Collaborations
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-3 col-lg-3 col-md-6 pb-30 wow tpfadeUp"
                data-wow-duration=".9s"
                data-wow-delay=".7s"
              >
                <div className="tp-footer__widget footer-widget-2 footer-col-2-3">
                  <h4 className="tp-footer__widget-title">Other Pages</h4>
                  <div className="tp-footer__content">
                    <ul>
                      <li>
                        <a href="/about" style={{ textDecoration: 'none' }}>
                          About
                        </a>
                      </li>
                      <li>
                        <a href="/contact" style={{ textDecoration: 'none' }}>
                          Contact
                        </a>
                      </li>
                      <li>
                        <a href="/RefundPolicy" style={{ textDecoration: 'none' }}>
                          Refund Policy
                        </a>
                      </li>
                      <li>
                        <a href="/TermsAndConditions" style={{ textDecoration: 'none' }}>
                          Terms And Conditions
                        </a>
                      </li>
                      <li>
                        <a href="/PrivacyPolicy" style={{ textDecoration: 'none' }}>
                          Privacy Policy
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tp-copyright__area pt-20 pb-20">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6">
                <div className="tp-copyright__social">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.facebook.com/profile.php?id=61565640062117&mibextid=ZbWKwL"
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a href="/">
                    <i className="fab fa-twitter" />
                  </a>
                  <a href="/">
                    <i className="fab fa-whatsapp" />
                  </a>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.instagram.com/lonoindia?igsh=YTd6Yjg0Y3RhNjd4&utm_source=qr"
                  >
                    <i className="fab fa-instagram" />
                  </a>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6  d-none d-md-block">
                <div className="tp-copyright__text tp-copyright__text-2 text-center">
                  <span>
                    Full Copyright &amp; Design By{' '}
                    <a href="/">@Busicon Services pvt Ltd</a> 2024
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* tp-footer-area-end */}
    </footer>
  )
}

export default Footer
